import { h, Component } from "preact";
import { css, keyframes } from "emotion";
import FocusTrap from "focus-trap-react";
import Button from "./Button";
const closeIcon = require("../assets/images/ic_close.svg");

const styles = {
  header: css`
    border-bottom: 1px solid #dedede;
    text-align: center;
    position: relative;
    width: 100%;
    padding: 18px 14px;
  `,
  title: css`
    font-size: 18px;
    font-weight: 600;
    display: inline-block;
  `,
  clearButton: css`
    position: absolute;
    right: 14px;
    display: inline-block;
    & > button {
      text-decoration: underline;
      color: #6621c0;
    }
  `,
  closeButton: css`
    border: none;
    position: absolute;
    background: #fff;
    left: 14px;
    width: 24px;
    height: 24px;
    background-image: url(${closeIcon});
  `,
  resultButton: css`
    width: 100%;
    position: absolute;
    bottom: 16px;
    padding: 0px 14px;
  `
};

/**
 * This modal display filter options (same as marketing page)
 *
 * @class FullHeightFilterModal
 * @extends {Component}
 */
class FullHeightFilterModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasOpened: false
    };
  }

  componentDidUpdate() {
    const { showModal } = this.props;
    if (showModal) {
      if (!this.state.hasOpened) {
        this.setState({ hasOpened: true });
      }
      this.addKeyDownListener();
      return;
    }
    this.removeKeyDownListener();
  }

  componentDidMount() {}

  componentWillUnmount() {
    this.removeKeyDownListener();
  }

  checkDocumentKeyDown = event => {
    const { closeHandler } = this.props;
    if (event.key === "Escape" || event.key === "Esc" || event.keyCode === 27) {
      closeHandler(event);
    }
  };

  addKeyDownListener() {
    document.addEventListener("keydown", this.checkDocumentKeyDown);
  }

  removeKeyDownListener() {
    document.removeEventListener("keydown", this.checkDocumentKeyDown);
  }
  render({
    showModal,
    closeHandler,
    title,
    contents,
    footer,
    children,
    clearFilter,
    destroy = true,
    mobileFilter
  }) {
    const hasOpened = this.state.hasOpened;
    const fadeIn = keyframes({
      from: {
        opacity: 0.5
      },
      to: {
        opacity: 1
      }
    });
    const grow = keyframes({
      from: {
        transform: `scale(0.9)`
      },
      to: {
        transform: `scale(1)`
      }
    });
    /* The Modal (background) */
    const modal = css({
      display: showModal ? "flex" : "none",
      justifyContent: "center",
      alignItems: "flex-start",
      position: "fixed",
      zIndex: 100001,
      paddingTop: 80,
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",
      background: "#fafafa",
      "@media(max-width: 600px)": {
        paddingTop: 0
      }
    });

    const modalBackground = css({
      backgroundColor: "rgba(0,0,0,0.6)",
      animation: `${fadeIn} 0.3s ease-in-out`,
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",
      overflow: "auto",
      position: "absolute",
      zIndex: 1
    });

    /* Modal Content */
    const modalContent = css({
      position: "relative",
      backgroundColor: "#fefefe",
      border: "1px solid #888",
      borderRadius: 4,
      display: "inline-block",
      animation: `${grow} 0.2s ease-in-out`,
      zIndex: 2,
      height: "100%",
      overflow: "scroll",
      minWidth: 300,
      maxHeight: "calc(100vh - 80px)",
      "@media(max-width: 600px)": {
        maxHeight: "100vh",
        paddingBottom: 80,
        minWidth: 200,
        width: "100%",
        borderRadius: 0
      }
    });

    return (
      <div className={modal}>
        <div className={modalBackground} />
        {showModal || (!destroy && hasOpened) ? (
          <FocusTrap>
            <div
              className={modalContent}
              aria-modal="true"
              role="dialog"
              id="modal-wrapper"
            >
              <div className={styles.header}>
                <button
                  type="button"
                  className={styles.closeButton}
                  onClick={closeHandler}
                  aria-label="Close"
                  data-cy="close"
                />
                <div className={styles.title}>{title}</div>
                <div className={styles.clearButton}>
                  <button onClick={clearFilter}>Clear</button>
                </div>
              </div>
              {contents ? <div>{contents}</div> : children}
              <div className={styles.resultButton}>
                <Button type="primary" fullWidth={true} onClick={mobileFilter}>
                  Show results
                </Button>
              </div>
            </div>
          </FocusTrap>
        ) : null}
      </div>
    );
  }
}

export default FullHeightFilterModal;



// WEBPACK FOOTER //
// ./components/FullHeightFilterModal.js